import { isInApp } from './isInApp';
import { isMobile } from './isMobile';

export { isInApp, isMobile };
